module.exports = __webpack_public_path__ + "img/small_eye_redchart02.31043119.jpg";